<template>
    <button class="top-link hide" id="js-top" @click="toTop">Return to top</button>
  </template>
  
  <script>
  export default {
    methods: {
      toTop() {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      }
    }
  }
  </script>
  
  <style scoped>
  .top-link {
    border: none;
  }
  </style>


// WEBPACK FOOTER //
// src/components/ScrollToTop.vue